import BevelOptionsEnum from '@/domains/sole/typescript/enums/BevelOptionsEnum';
import TemplateFittingEnum from '@/domains/sole/typescript/enums/TemplateFittingEnum';
import buildCorrectionParameters from '@/domains/sole/services/buildCorrectionParameters';
import ManufactureTypeEnum from '@/domains/scan/typescript/enums/ManufactureTypeEnum';
import type SoleCorrectionsInterface from '@/domains/sole/typescript/interfaces/SoleCorrectionsInterface';
import type SoleMorphingInterface from '@/domains/sole/typescript/interfaces/SoleMorphingInterface';
import type SoleParametersInterface from '@/domains/sole/typescript/interfaces/SoleParametersInterface';
import type SoleInformationInterface from '@/domains/sole/typescript/interfaces/SoleInformationInterface';
import type SoleConfigurationInterface from '@/domains/sole/typescript/interfaces/SoleConfigurationInterface';

const {
    SoleThickness,
    GapFirstHead,
    GapFifthHead,
    InterArchPoint,
    InterArchPointConcavity,
    InternalArch,
    InternalArchSummitsPosition,
    ExternalArch,
    ExternalArchSummitsPosition,
    AddedThicknessHeel,
    MedialCupolaHeight,
    LateralCupolaHeight,
    FlatnessHeel,
    HeelWidening,
    MidfootWidening,
    MetatarsalWidening,
    TotalPatternWidening,
    HeelBevelHeight,
    FrontBevelHeight,
    FullLengthBevelHeight,
} = buildCorrectionParameters();

const defaultSoleParameters: SoleParametersInterface = {
    soleThickness: { ...SoleThickness.default }.id,
    thickerFrontFoot: false,
    gapFirstHead: { ...GapFirstHead.default }.id,
    gapFifthHead: { ...GapFifthHead.default }.id,
    interArchPoint: { ...InterArchPoint.default }.id,
    interArchPointConcavity: parseInt(InterArchPointConcavity.default.name, 10),
    internalArch: { ...InternalArch.default }.id,
    internalArchSummitsPosition: parseInt(InternalArchSummitsPosition.default.name, 10),
    externalArch: { ...ExternalArch.default }.id,
    externalArchSummitsPosition: parseInt(ExternalArchSummitsPosition.default.name, 10),
    addedThicknessHeel: { ...AddedThicknessHeel.default }.id,
    medialCupolaHeight: { ...MedialCupolaHeight.default }.id,
    lateralCupolaHeight: { ...LateralCupolaHeight.default }.id,
    flatnessHeel: parseInt(FlatnessHeel.default.name, 10),
};

const defaultSoleCorrections: SoleCorrectionsInterface = {
    heelWidening: { ...HeelWidening.default }.id,
    midfootWidening: { ...MidfootWidening.default }.id,
    metatarsalWidening: { ...MetatarsalWidening.default }.id,
    totalPatternWidening: { ...TotalPatternWidening.default }.id,
    heelBevel: BevelOptionsEnum.No,
    heelBevelHeight: { ...HeelBevelHeight.default }.id,
    frontFootBevel: BevelOptionsEnum.No,
    frontFootBevelHeight: { ...FrontBevelHeight.default }.id,
    fullLengthBevel: BevelOptionsEnum.No,
    fullLengthBevelHeight: { ...FullLengthBevelHeight.default }.id,
    heelStabilizer: false,
};

const defaultSoleMorphing: SoleMorphingInterface = {
    front: null,
    middle: null,
    back: null,
};

const defaultSoleInformations: SoleInformationInterface = {
    sanded: false,
    templateFitting: TemplateFittingEnum.None,
    cuttingLength: 0,
    manufacture: ManufactureTypeEnum.Milling,
    coveringMaterial: 0,
};

const defaultSoleConfiguration: SoleConfigurationInterface = {
    sole: '0',
    pattern: '0',
    heelPad: '0',
    metatarsalPad: '0',
    fullLengthPad: '0',
    isMaunalBend: false,
};

const ZERO_PARAMETER_VALUE = '0';

export {
    ZERO_PARAMETER_VALUE,
    defaultSoleParameters,
    defaultSoleCorrections,
    defaultSoleMorphing,
    defaultSoleInformations,
    defaultSoleConfiguration,
};
